var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<input type=\"text\" uib-popover-template=\"$ctrl.popoverUrl\" popover-placement=\"{{::$ctrl.popoverPlacement || 'bottom-left'}}\" popover-trigger=\"'outsideClick'\" ng-style=\"{'background-color': $ctrl.color, 'color': $ctrl.isDark() && '#fff'}\" ng-model=\"$ctrl.color\" class=\"form-control m-t-0 text-center {{::$ctrl.classes}}\" placeholder=\"#RRGGBB\"/>";
var id1="color-input.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;